import React, { useState } from 'react';


const TAB_CONTENT = {
  about: (
    <div>
      <div style={{ fontSize: '1.0rem', color: '#333'}}>
        <p>MangaloreHub.com is your one-stop services hub for everything in Mangalore and beyond. We connect users to local businesses & services.
           Our mission is to make life easier for residents and visitors by providing a 
           comprehensive, easy-to-use platform.</p>
      </div>
      <div style={{ marginTop: '2.2rem' }}>
        <h3 style={{ color: '#1976d2', fontSize: '1.0rem', marginBottom: '0.rem' }}>Privacy Policy</h3>
        <a href="/privacypolicy" style={{ color: '#0288d1', textDecoration: 'none', fontSize: '.8rem' }}>View our Privacy Policy</a>
      </div>
    </div>
  ),
  advertise: (
    <div>
      <div style={{ fontSize: '1.0rem', color: '#333' }}>
        <p>Promote your business or service to thousands of local users! We offer banner ads, featured listings, and custom advertising packages. Contact us at <a href="mailto:ads@mangalorehub.com">ads@mangalorehub.com</a> for rates and options.</p>
      </div>
    </div>
  ),
  contact: null, // Will be filled below
};

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [tab, setTab] = useState('contact');
  const apiBase = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
    setError(''); // Clear error when user types
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!apiBase) {
      setError('API base URL is not configured. Please set REACT_APP_API_BASE in .env.');
      return;
    }

    setLoading(true);
    setError('');
    
    try {
      const response = await fetch(`${apiBase}/api/send`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(form)
      });

      const responseText = await response.text();
      let data = null;
      try {
        data = responseText ? JSON.parse(responseText) : null;
      } catch {
        data = null;
      }
      
      if (response.ok && data.success) {
        setSubmitted(true);
        setForm({ name: '', email: '', message: '' });
        setTimeout(() => setSubmitted(false), 4000);
      } else {
        setError((data && data.error) || 'Failed to send message. Please try again.');
      }
    } catch (err) {
      console.error('Error sending message:', err);
      setError('Unable to connect to server. Please make sure the server is running.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ paddingLeft: 12 }}>
      <div style={{ display: 'flex', gap: '.3rem', fontSize: '.4rem', marginBottom: '1rem', borderBottom: '1px solid #e0e0e0' }}>
        <button onClick={() => setTab('about')} style={{ background: 'none', border: 'none', borderBottom: tab === 'about' ? '1px solid #1976d2' : 'none', color: tab === 'about' ? '#1976d2' : '#333', fontWeight: 600, fontSize: '.9rem', padding: '0.5rem 0.7rem', cursor: 'pointer' }}>About Us</button>
        <button onClick={() => setTab('advertise')} style={{ background: 'none', border: 'none', borderBottom: tab === 'advertise' ? '1px solid #1976d2' : 'none', color: tab === 'advertise' ? '#1976d2' : '#333', fontWeight: 600, fontSize: '.9rem', padding: '0.5rem 0.7rem', cursor: 'pointer' }}>Advertise with us</button>
        <button onClick={() => setTab('contact')} style={{ background: 'none', border: 'none', borderBottom: tab === 'contact' ? '1px solid #1976d2' : 'none', color: tab === 'contact' ? '#1976d2' : '#333', fontWeight: 600, fontSize: '.9rem', padding: '0.5rem 0.7rem', cursor: 'pointer' }}>Contact Us</button>
      </div>
      {tab === 'contact' ? (
        <>
          <div style={{ fontSize: '1.0rem', color: '#333', lineHeight: 1.3 }}>
            <div><strong>Email:</strong> info@mangalorehub.com</div>
            <div><strong>Phone:</strong> +91 9########0</div>
            <div><strong>Address:</strong> Mangalore, Karnataka, India</div>
            <div><strong>Support Hours:</strong> Mon-Fri, 9:00 AM - 6:00 PM</div>
          </div>
          <div style={{ marginTop: '1.5rem', fontSize: '0.98rem', color: '#555' }}>
            For any queries, feedback, or support, please reach out to us using the above contact details. We are here to help you!
          </div>
          <form style={{ marginTop: '1.0rem', display: 'flex', flexDirection: 'column', gap: '1rem' }} onSubmit={handleSubmit}>
            <div>
              <label htmlFor="name" style={{ display: 'block', marginBottom: 4 }}>Name</label>
              <input id="name" name="name" type="text" required value={form.name} onChange={handleChange} style={{ width: '100%', padding: '8px', borderRadius: 4, border: '1px solid #ccc' }} />
            </div>
            <div>
              <label htmlFor="email" style={{ display: 'block', marginBottom: 4 }}>Email</label>
              <input id="email" name="email" type="email" required value={form.email} onChange={handleChange} style={{ width: '100%', padding: '8px', borderRadius: 4, border: '1px solid #ccc' }} />
            </div>
            <div>
              <label htmlFor="message" style={{ display: 'block', marginBottom: 4 }}>Message</label>
              <textarea id="message" name="message" rows={4} required value={form.message} onChange={handleChange} style={{ width: '100%', padding: '8px', borderRadius: 4, border: '1px solid #ccc' }} />
            </div>
            <button type="submit" disabled={loading} style={{ background: loading ? '#bdbdbd' : '#1976d2', color: '#fff', padding: '10px 0', border: 'none', borderRadius: 4, fontWeight: 600, fontSize: '1rem', cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? 'Sending...' : 'Send Message'}
            </button>
            {submitted && <div style={{ color: '#388e3c', marginTop: 8, fontWeight: 600 }}>✓ Thank you! Your message has been sent successfully.</div>}
            {error && <div style={{ color: '#d32f2f', marginTop: 8, fontWeight: 600 }}>✗ {error}</div>}
          </form>
        </>
      ) : (
        TAB_CONTENT[tab]
      )}
    </div>
  );
};

export default Contact;